import {Component, Input, OnInit} from '@angular/core';
import * as FileSaver from 'file-saver';
import {WorldInformationRestService} from '../../shared/services/nso-data-portal/rest-services/world-information-rest.service';
import {FileUtilsService} from '../../shared/services/common/file/file-utils.service';
import {SelectItem} from 'primeng/api';
import {GlobalMessagesService} from '../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {SearchEntityLevels} from '../../shared/types/nso-data-portal/search-entity-levels';
import {RegionInformationRestService} from '../../shared/services/nso-data-portal/rest-services/region-information-rest.service';
// eslint-disable-next-line max-len
import {OrganizationInformationRestService} from '../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';

@Component({
  selector: 'wsd-ndp-export',
  templateUrl: './ndp-export.component.html',
  styleUrls: ['./ndp-export.component.css']
})
export class NdpExportComponent implements OnInit {

  @Input()
  entityId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  FIRST_YEAR: number = 2017;

  BUTTON_PREFIX: string = 'DATA_PORTAL.EXPORT.BUTTON_';

  searchEntityLevels = SearchEntityLevels;

  selectedYear: number;

  yearOptions: SelectItem[] = [];

  block: Boolean = false;

  constructor(private worldInformationRestService: WorldInformationRestService,
              private regionalInformationRestService: RegionInformationRestService,
              private organizationInformationRestService: OrganizationInformationRestService,
              private fileUtils: FileUtilsService,
              private message: GlobalMessagesService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.generateExportOptions();
  }

  private generateExportOptions() {
    const currentYear = new Date().getFullYear();
    this.yearOptions.push({label: '', value: currentYear});

    for (let yearValue = this.FIRST_YEAR; yearValue <= currentYear; yearValue++) {
      this.yearOptions.push({label: yearValue.toString(), value: yearValue});
    }
  }

  export() {
    this.block = true;
    switch (this.entityLevel) {
      case SearchEntityLevels.WORLD:
        return this.worldInformationRestService.getNDPExport(this.selectedYear != null ? this.selectedYear : this.FIRST_YEAR)
          .subscribe(response => {
            FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response));
            this.block = false;
          }, (error) => {
            this.block = false;
            this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.EXPORT.ERROR'));
          });
      case SearchEntityLevels.REGION:
        return this.regionalInformationRestService.getNDPExport(this.selectedYear != null ? this.selectedYear : this.FIRST_YEAR,
          this.entityId)
          .subscribe(response => {
            FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response));
            this.block = false;
          }, (error) => {
            this.block = false;
            this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.EXPORT.ERROR'));
          });
      case SearchEntityLevels.ORGANIZATION:
        return this.organizationInformationRestService.getNDPExport(this.selectedYear != null ? this.selectedYear : this.FIRST_YEAR,
          this.entityId)
          .subscribe(response => {
            FileSaver.saveAs(response.body, this.fileUtils.extractFileName(response));
            this.block = false;
          }, (error) => {
            this.block = false;
            this.message.showErrorMessage(this.translate.instant('DATA_PORTAL.EXPORT.ERROR'));
          });

    }

  }

}
